module.exports = __webpack_public_path__ + "img/lead-hotels.8e514e0e.svg";